import { useAutoSEO } from '../../hooks/useSEOFromRoute';
import Hero from './components/Hero';
import CommonIssues from './components/CommonIssues';
import CoreCapabilities from './components/CoreCapabilities';
import TargetAudience from './components/TargetAudience';
import BrandStatement from './components/BrandStatement';
import Commitment from './components/Commitment';
import ContactCTA from './components/ContactCTA';

export default function DigitalTransformationConsultingPage() {
  // Auto fetch SEO from database based on route (/dich-vu/tu-van-chuyen-doi-so)
  useAutoSEO();

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <CommonIssues />
      <CoreCapabilities />
      <TargetAudience />
      <BrandStatement />
      <Commitment />
      <ContactCTA />
    </div>
  );
}
